<template>
  <div />
</template>

<script>
export default {
  name: 'Login',
  async created() {
    await this.checkToken();
  },
  methods: {
    async checkToken() {
      const token = this.$route.hash.split('token=')[1];
      console.log(token)
      if (token) {
        console.log('Checking Token');
        if (token !== localStorage.getItem('token')) {
          console.log('Token distinto');
          const response = await this.$store.dispatch('loginByToken', token);
          if (!response.success) {
            console.log(':(');
            this.redirectDashboard();
          } else {
            console.log(':D');
            this.redirectLoggedUser();
          }
        } else {
          this.redirectLoggedUser();
        }
      } else {
        this.redirectDashboard();
      }
    },
    setGoogle() {
      // Setea usuario en Google Analytics
      this.$ga.set('admin', this.$store.getters.role.admin || false);
      this.$ga.set('account_type', this.$store.getters.role.role);
      this.$ga.set('account', this.$store.getters.user.rut);
      this.$ga.set('account_name', `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`);
    },
    async redirectLoggedUser() {
      const haveAccess = await this.$store.dispatch('getRoles');
      if (haveAccess) {
        await this.$store.dispatch('setRole');
        this.setGoogle();
        this.$router.push({ name: 'SelectRoles' });
      } else {
        this.$router.push({ name: 'permisoDenegado' });
      }
    },
    redirectDashboard() {
      console.log('Redireccionando a dashboard');
      if (window.location.hostname.includes('release.bhp.lifeon.cl')) {
        window.location = 'https://release.bhp.lifeon.cl';
      } else if (window.location.hostname.includes('release.amsa.lifeon.cl')) {
        window.location = 'https://release.amsa.lifeon.cl';
      } else if (window.location.hostname.includes('dev.lifeon.cl')) {
        window.location = 'https://bhp.dev.lifeon.cl';
      } else if (window.location.hostname.includes('localhost')) {
        console.log('Dashboard');
      } else {
        window.location = 'https://bhp.lifeon.cl';
      }
    },
  },
};
</script>

<style scoped>
#bg {
  z-index: -1;
  position: fixed;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
}

#bg img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  min-width: 50%;
  min-height: 50%;
}

.login {
  /*position: absolute;*/
  padding: 50px 50px 40px 50px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  max-width: 400px;
  /*top: 40px;
  left: 60px;*/
  /*box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.75);*/
  border: 2px solid #ccc;

  margin: 0 auto;
  margin-top: 80px;
}

.title {
  color: rgb(246, 123, 47);
  font-weight: bold;
  font-size: 25px;
  margin-top: 30px;
  margin-bottom: 10px;
}

.logo-bhp {
  max-width: 100%;
}

.logo-escondida {
  max-width: 100%;
}

.el-alert {
  margin-bottom: 10px;
}

.button {
  width: 100%;
}

@media (max-width: 768px) {
  .login {
    border: none;
    margin-top: 40px;
    margin-right: 10px;
    margin-left: 10px;
    position: static;
    padding: 30px 30px 20px 30px;
  }
}
.poweredSafety {
  text-align: center;
}
.poweredSafety img {
  margin-top: 5px;
  max-width: 180px;
}
.video-tutorial {
  padding: 20px 0;
  margin: 0 auto;
  margin-top: 80px;

  text-align: center;
  color: rgb(246, 123, 47);
  background-color: hsl(0, 0%, 93%);
}
.video-tutorial h3 {
  margin-top: 10px;
}
</style>
